var _style, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJmaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 1345",
    style: {
      enableBackground: "new 0 0 2500 1345"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,1075.2C0,1236.9,101.6,1345,292.2,1345l0,0c192.7,0,303.4-113.3,303.4-276c0-103.6,0-658.5,0-658.5H381.2 c0,0,0,570.4,0,642.9c0,58.7-29.3,100-89,100c-55.7,0-90-34.9-90-98.3V952.7H0V1075.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1158.5,841.4 1018.7,410.4 713.9,410.4 713.9,1331.9 926.8,1331.9 926.8,706.7 1065.7,1129.3  1251.2,1129.3 1390.1,706.7 1390.1,1331.9 1603,1331.9 1603,410.4 1298.2,410.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2265.3,1331.9h229.2l-258-921.5h-293.8l-258,921.5h229.2l52.7-201.9h245.9L2265.3,1331.9z M2014.1,948.2 l75.5-288.8h0l75.5,288.8H2014.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2089.6619,
    y1: 820.8577,
    x2: 2089.6619,
    y2: 0.000001472378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001847",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001544",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#00477C",
      stopOpacity: 0.4628
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8129,
    style: {
      stopColor: "#0067A0",
      stopOpacity: 0.8129
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0073AD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2089.7,184.9c-124.5,0-225.5,101-225.5,225.5c0,48.8,15.5,93.9,41.9,130.8l36.6-130.8 c0-81.2,65.8-147,147-147c81.2,0,147,65.8,147,147c0,0.2,0,0.4,0,0.6l36.5,130.4c26.4-36.9,42-82.1,42-131 C2315.1,285.9,2214.2,184.9,2089.7,184.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2089.6619,
    y1: 820.8577,
    x2: 2089.6619,
    y2: 0.000001472437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001847",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001544",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#00477C",
      stopOpacity: 0.4628
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8129,
    style: {
      stopColor: "#0067A0",
      stopOpacity: 0.8129
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0073AD"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1767.4,410.4c0-178,144.3-322.3,322.3-322.3c178,0,322.3,144.3,322.3,322.3c0,95.8-41.8,181.7-108.1,240.8 l25.8,92.1c103.2-74.5,170.4-195.8,170.4-332.8C2500,183.8,2316.3,0,2089.7,0c-226.6,0-410.3,183.8-410.3,410.4 c0,137,67.1,258.2,170.2,332.7l25.8-92.1C1809.1,592,1767.4,506.1,1767.4,410.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmaLogo);
export default __webpack_public_path__ + "static/media/jma-logo.2b6c96d1c8f00e585c81d1f51e0280f5.svg";
export { ForwardRef as ReactComponent };